import Switch from '@mui/material/Switch'
import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  TableFooter,
  Button
} from 'components'
import { IFornecedor } from 'services/NGT/SupplierRegistration'
import { COLORS, FORMAT } from 'utils'

interface ITableSearchSupplier {
  tableData: IFornecedor[]
  selectedSupplier: (supplier: IFornecedor) => void
  page: number
  setPage: (page: number) => void
  setRowsPerPage: (rowsPerPage: number) => void
  rowsPerPage: number
  totalItems: number
}

const TableSearchSupplier = ({
  tableData,
  selectedSupplier,
  setRowsPerPage,
  setPage,
  page,
  rowsPerPage,
  totalItems
}: ITableSearchSupplier) => {
  const handleChangePage = (newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left" style={{ paddingLeft: '0.8rem' }}>Código</TableCellStyled>
              <TableCellStyled align="center">Código SAP</TableCellStyled>
              <TableCellStyled align="center">Tipo</TableCellStyled>
              <TableCellStyled align="center">
                CPF/CNPJ/Cód.Fornecedor
              </TableCellStyled>
              <TableCellStyled align="left">Nome do Fornecedor</TableCellStyled>
              <TableCellStyled align="center">Contato Comercial</TableCellStyled>
              <TableCellStyled align="center">E-mail</TableCellStyled>
              <TableCellStyled align="center">Responsavel</TableCellStyled>
              <TableCellStyled align="center">SAP</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData.length > 0 &&
              tableData.map((row, index) => (
                <TableRowStyled key={`${index}-${row.idFornecedor}`}>
                  <TableCellStyled align="left">
                    <Button
                      text={row.cdFornecedor}
                      textColor={COLORS.blueFonts}
                      variantButton="text"
                      onClick={() => selectedSupplier(row)}
                    />
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.cdFornecedorSap || '---'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.cdTipoFornecedor === 'F' ? 'Pessoa Física' : null}
                    {row.cdTipoFornecedor === 'J' ? 'Pessoa Jurídica' : null}
                    {row.cdTipoFornecedor === 'E' ? 'Estrangeiro' : null}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.cdTipoFornecedor === 'E'
                      ? row.cdDocto
                      : FORMAT.documento(row.cdDocto)}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row.nmFornecedor}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {FORMAT.contatoInternacional(row.nuTelefone)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.txEmailResponsavel}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.nmResponsavel}
                  </TableCellStyled>
                  <TableCellStyled>
                    {row.flSap ? (
                      <Switch disabled defaultChecked />
                    ) : (
                      <Switch disabled />
                    )}
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        totalItems={totalItems}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}

export default TableSearchSupplier
